import { useRef, useState } from "react";
import CreateIssue from "../CreateIssue/CreateIssue";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";
import { useTranslation } from "react-i18next";
// import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextBoxComponent";
import { getBackendUrl } from "@Utils";

function CreateIssueModal({
  extraParametersOnIssueCreation = {},
  closeModal,
  refreshDataGrid,
  projectId,
  attachedReviewId,
  defaultSpaceId = null,
}) {
  const { t } = useTranslation();
  const dropDownRef = useRef();
  const [spaceId, setSpaceId] = useState(defaultSpaceId);

  const [query] = useState({
    projectId: projectId,
    params: {
      projectId: projectId,
    },
  });

  const handleChange = (e, newValue) => {
    setSpaceId(newValue?._id);
  };

  const headerContent = () => (
    <div className="  w-full flex justify-between rounded-md items-center">
      <div className="">{t("Create Issue")}</div>
    </div>
  );

  const getOptionsLabel = (args) => {
    console.log(args);
    return args.spaceName;
  };

  const getSpacesDropdown = () => (
    <AutoComplete
      ref={dropDownRef}
      remoteDataSource={`${getBackendUrl()}/spaces/spacesData`}
      query={query}
      valueField="_id"
      getOptionLabel={getOptionsLabel}
      onChange={handleChange}
      // width="auto"
      value={spaceId}
      width="250px"
      popperWidth="350px"
      disabled={Boolean(defaultSpaceId)}
      renderInput={(params) => <TextFieldComponent {...params} />}
    />
  );

  const modelContent = () => (
    <>
      <div className="flex gap-2 bg-white items-center">
        <div>{t("Select space:")}</div>
        {getSpacesDropdown()}
      </div>
      {spaceId && (
        <div className="h-600">
          <CreateIssue
            extraParametersOnIssueCreation={extraParametersOnIssueCreation}
            isStandalone
            onCancel={closeModal}
            workspaceId={spaceId}
            refreshDataGrid={refreshDataGrid}
            attachedReviewId={attachedReviewId}
          />
        </div>
      )}
    </>
  );

  return (
    <ModalStateDialogComponent
      isVisible
      onCancel={closeModal}
      zIndex={30000}
      allowModalPadding={false}
      width="70%"
      headerTitle={headerContent()}
      modelContent={modelContent()}
    />
  );
}

export default CreateIssueModal;
